<template>
  <div class="cont">
    <!-- <el-carousel trigger="click" height="547px" :interval="5000" :autoplay="false">


      <el-carousel-item v-for="item in 4" :key="item"></el-carousel-item>
    </el-carousel>-->
    <div class="inner" :class="navBarFixed == true ? 'active' :''">
      <div class="item">
        <el-container class="container">
          <router-link :to="{ name: 'Home' }">
            <el-aside width="255px" class="aside"></el-aside>
          </router-link>

          <el-main style="overflow:hidden;padding:0" class="amain">
            <div class="top">
              <!-- <span class="item" style="margin : 0 10px">会员登录</span>
              <span>|</span> -->
              <span class="item" style="margin : 0 10px" @click="jprouter">日文</span>
              <span>|</span>
              <span class="item" style="margin : 0 10px" @click="enrouter">英文</span>
            </div>
            <div class="bottom">
              <router-link :to="{ name: 'Brand' }" tag="div">
                <span class="item" style="margin : 0 10px;font-weight:700 ; font-size:16px">DIXCEL品牌</span>
              </router-link>
              <span>|</span>
              <router-link :to="{ name: 'Brake' }" tag="div">
                <span class="item" style="margin : 0 10px">各类产品</span>
              </router-link>
              <span>|</span>
              <router-link :to="{ name: 'BrakeClassroom' }" tag="div">
                <span class="item" style="margin : 0 10px">制动课堂</span>
              </router-link>
              <span>|</span>
              <router-link :to="{ name: 'Moment' }" tag="div">
                <span class="item" style="margin : 0 10px">精彩瞬间</span>
              </router-link>

              <span>|</span>
              <router-link :to="{ name: 'ShopMallOnline' }" tag="div">
                <span class="item" style="margin : 0 10px">购买渠道</span>
              </router-link>
              <span>|</span>
              <span class="item" style="margin : 0 10px" @click="contactClick">联系我们</span>
            </div>
          </el-main>
        </el-container>
      </div>
    </div>
  </div>
</template>

<script>

// position : fixed;
// display : block ;
// z-index : 999;
// background-color : #000;
// width :100%;
// opacity : 0%

export default {
  name: "ContOne" ,
  data() {
    return {
      navBarFixed : false  ,  //是否吸顶
    }
  },
  mounted () {
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
  },
  destroyed(){
    window.removeEventListener('scroll', this.watchScroll);
  },
  methods: {
    watchScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

      // console.log( scrollTop )
      //当滚动超过 115 时，实现吸顶效果
      if (scrollTop > 158) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    } ,

    //跳转至联系我们
    contactClick(){
      document.querySelector("#contact").scrollIntoView(true);
    }
  } ,

};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  color: #fff;
  margin: 0 auto;
  position : relative
  box-sizing: border-box;
  background: url("~@/assets/image/brand/img1.png");
  background-size 100% 100%
  background-color #fff
}
  .inner.active{
    position:fixed;
    // left : 0 ;
    // top : 0 ;
    z-index:999;
    background-color : rgba(0, 0, 0 , 80%);
    box-sizing:border-box ;
    // width : 100% ;
    width : 1003px
  }

  .inner {
    padding: 31px 59px;
    box-sizing: border-box;
    background-color : rgba(0, 0, 0 , 0%)
    width : 100% ;
  }

    .item {
      border-bottom: 1px solid #fff;
      padding-bottom: 13px;
    }

      .aside {
        overflow: hidden;
        width: 255px;
        height: 60px;
        background-color: #fff;
        background: url("~@/assets/image/home/home1/LOGO.png");
        background-repeat : no-repeat
        background-size : contain
      }

      .amain {
        overflow: hidden;
        padding: 0;
      }

        .top {
          height: 14px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          display: flex;
          justify-content: flex-end;
          margin-bottom: 15px;
          margin-top: 10px;
        }

        .bottom {
          height: 17px;
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          display: flex;
          justify-content: flex-end;
        }
        .item {
          border-bottom: none
          padding-bottom: 0px;
        }
.item:hover{
  color : #f90000
  font-style  : normal ;
  cursor pointer
}
.container {
  padding-bottom 10px
  border-bottom 1px solid #fff
}
</style>
